import React from 'react';
import { useParams } from 'react-router';
import { PageLayout } from 'containers/layout';
import { CenterContainer } from 'components/common';

const Page = () => {
  const { name } = useParams();

  return (
    <PageLayout title={name}>
      <CenterContainer name={name} />
    </PageLayout>
  );
};

export default Page;
